import { gql, TypedDocumentNode } from "@apollo/client";

import { AzureDevOpsRepoIntegration, QueryAzureDevOpsRepoIntegrationArgs } from "types/generated";

export type AzureDevOpsIntegrationData = Pick<
  AzureDevOpsRepoIntegration,
  | "vcsChecks"
  | "vcsCheckOptions"
  | "useGitCheckout"
  | "description"
  | "id"
  | "labels"
  | "name"
  | "isDefault"
  | "space"
  | "organizationURL"
  | "userFacingHost"
  | "webhookUrl"
  | "accessibleProjects"
>;

type GetAzureDevOpsIntegrationData = {
  azureDevOpsRepoIntegration: AzureDevOpsIntegrationData;
};

export const GET_AZURE_DEVOPS_INTEGRATION: TypedDocumentNode<
  GetAzureDevOpsIntegrationData,
  QueryAzureDevOpsRepoIntegrationArgs
> = gql`
  query GetAzureDevOpsIntegration($id: ID!) {
    azureDevOpsRepoIntegration(id: $id) {
      vcsChecks
      vcsCheckOptions {
        individualFailuresOnly
        individualSkipUnchanged
      }
      useGitCheckout
      description
      id
      labels
      name
      isDefault
      space {
        id
        name
        accessLevel
      }
      organizationURL
      userFacingHost
      webhookUrl
      accessibleProjects
    }
  }
`;
